import {
  singleItemWrapper,
  pagedListWrapper
} from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Referral, Stat, Settings } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { get: getStat } = singleItemWrapper<Stat>(apiClient, {
      path: `/api/v${version}/referrals/stat`
    })

    const { get: getSettings } = singleItemWrapper<Settings>(apiClient, {
      path: `/api/v${version}/referrals/settings`
    })

    // @ts-expect-error: TODO: rewrite generics type parameters
    const referrals = pagedListWrapper<'id', Referral>()(apiClient, {
      path: `/api/v${version}/referrals`,
      idKey: 'id'
    })

    return { getStat, getSettings, referrals }
  }
} satisfies Starter
